export const reploBuilderFeatureList = [
  "Launch a whole website for free on Replo or connect your own domain",
  "Build high-converting landing pages and product pages in seconds with AI",
  "Sell products with our built-in checkout or use our Shopify integration to import existing products",
  "Connect with Instagram/Tiktok ads and Google analytics out of the box",
];
